const stripeActionConstants = {
  GET_CUSTOMER: 'GET_CUSTOMER',
  GET_CUSTOMER_SUCCESS: 'GET_CUSTOMER_SUCCESS',
  GET_CUSTOMER_ERROR: 'GET_CUSTOMER_ERROR',

  UPDATE_CUSTOMER_PAYMENT_METHOD: 'UPDATE_CUSTOMER_PAYMENT_METHOD',
  UPDATE_CUSTOMER_PAYMENT_METHOD_SUCCESS: 'UPDATE_CUSTOMER_PAYMENT_METHOD_SUCCESS',
  UPDATE_CUSTOMER_PAYMENT_METHOD_ERROR: 'UPDATE_CUSTOMER_PAYMENT_METHOD_ERROR',
};

export default stripeActionConstants;
